var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	"webpack/sharing/consume/default/react/react": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "../../node_modules/react/index.js"))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	"webpack/sharing/consume/default/react/jsx-runtime/react/jsx-runtime": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_react_jsx-runtime_js").then(() => (() => (__webpack_require__(/*! react/jsx-runtime */ "../../node_modules/react/jsx-runtime.js"))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	"webpack/sharing/consume/default/@appshell/react/@appshell/react": {
		fallback: () => (__webpack_require__.e("react_src_index_ts").then(() => (() => (__webpack_require__(/*! @appshell/react */ "../react/src/index.ts"))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@appshell/react",

	},
	"webpack/sharing/consume/default/react-dom/react-dom": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_react-dom_index_js").then(() => (() => (__webpack_require__(/*! react-dom */ "../../node_modules/react-dom/index.js"))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	"webpack/sharing/consume/default/@appshell/runtime/@appshell/runtime": {
		fallback: () => (__webpack_require__.e("runtime_src_index_ts").then(() => (() => (__webpack_require__(/*! @appshell/runtime */ "../runtime/src/index.ts"))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.0.0-alpha.140",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@appshell/runtime",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"webpack_sharing_consume_default_react_react": [
		"webpack/sharing/consume/default/react/react"
	],
	"webpack_sharing_consume_default_react_jsx-runtime_react_jsx-runtime": [
		"webpack/sharing/consume/default/react/jsx-runtime/react/jsx-runtime"
	],
	"src_bootstrap_tsx-webpack_sharing_consume_default_react-dom_react-dom": [
		"webpack/sharing/consume/default/@appshell/react/@appshell/react",
		"webpack/sharing/consume/default/react-dom/react-dom"
	],
	"react_src_index_ts": [
		"webpack/sharing/consume/default/@appshell/runtime/@appshell/runtime"
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}